import React, {Component} from 'react';
import DateSince from "../Date";

class DateRoom extends Component {
    constructor(props) {
        super(props);
        this.interval = null;
        this.state = {time: Date.now()};
    }

    componentDidMount() {
        this.interval = setInterval(() => this.setState({time: Date.now()}), (60000));
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <DateSince
                date={this.props.lastMessageCreatedAt}
                prefix={true}
                currentFormat={true}
            />
        )
    }
}


export default DateRoom;

